module.exports = __webpack_public_path__ + "img/recorder-screen.47e7d111.png";